// src/components/resumo/layout/AutoHideFooter.tsx
// 🎯 Footer que aparece quando chega perto do final da página

import React, { useEffect, useState } from 'react';
import './AutoHideFooter.css';

interface AutoHideFooterProps {
    children: React.ReactNode;
    darkMode?: boolean;
    threshold?: number; // Distância do final para mostrar (px)
    scrollContainerRef?: React.RefObject<HTMLElement | null>;
}

const AutoHideFooter: React.FC<AutoHideFooterProps> = ({
    children,
    darkMode = false,
    threshold = 200,
    scrollContainerRef
}) => {
    const [isVisible, setIsVisible] = useState(false);
    const [hasScrolled, setHasScrolled] = useState(false);

    useEffect(() => {
        let ticking = false;

        const handleScroll = () => {
            if (ticking) return;

            ticking = true;

            requestAnimationFrame(() => {
                const scrollContainer = document.getElementById('rrp-scroll-container');
                const isFullscreen = !!document.fullscreenElement;

                let distanceFromBottom = 0;
                let scrollTop = 0;

                if (isFullscreen && scrollContainer) {
                    scrollTop = scrollContainer.scrollTop;
                    distanceFromBottom = scrollContainer.scrollHeight - (scrollContainer.scrollTop + scrollContainer.clientHeight);
                } else {
                    const windowHeight = window.innerHeight;
                    const documentHeight = document.documentElement.scrollHeight;
                    scrollTop = window.scrollY;
                    distanceFromBottom = documentHeight - (scrollTop + windowHeight);
                }

                if (scrollTop > 0 && !hasScrolled) {
                    setHasScrolled(true);
                }

                if (hasScrolled) {
                    setIsVisible(distanceFromBottom < threshold);
                } else {
                    setIsVisible(false);
                }

                ticking = false;
            });
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        window.addEventListener('resize', handleScroll);

        const scrollContainer = document.getElementById('rrp-scroll-container');
        if (scrollContainer) {
            scrollContainer.addEventListener('scroll', handleScroll, { passive: true });
        }

        handleScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
            if (scrollContainer) {
                scrollContainer.removeEventListener('scroll', handleScroll);
            }
        };
    }, [threshold, hasScrolled]);

    return (
        <div
            className={`auto-hide-footer ${isVisible ? 'visible' : 'hidden'
                } ${darkMode ? 'dark' : ''}`}
        >
            {children}
        </div>
    );
};

export default AutoHideFooter;
